import { useEffect, useRef } from 'react';
import axios from 'axios';
import { ADMIN_CHECK_STATUS } from '../utils';
import { forceLogoutInactive } from '../actions/auth';
import { isNetworkOrServerError } from '../utils/networkErrorUtils';

const CHECK_INTERVAL_MS = 15 * 60 * 1000; // 15 menit
const BACKOFF_MS = 60000; // 60 detik saat gagal jaringan

/**
 * Hook untuk pengecekan berkala status admin.aktif.
 * Jika aktif !== 'ya' → forceLogoutInactive().
 * Backoff 60 detik saat gagal jaringan (tidak spam saat server down).
 */
export function useStatusAktifCheck() {
  const lastNetworkErrorAt = useRef(0);

  useEffect(() => {
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    if (!user || !token) return;

    const checkStatus = async () => {
      const now = Date.now();
      if (now - lastNetworkErrorAt.current < BACKOFF_MS) return;

      try {
        const res = await axios.get(ADMIN_CHECK_STATUS, {
          withCredentials: true,
        });
        const aktif = (res?.data?.aktif || '').toString().trim().toLowerCase();
        if (aktif === 'tidak') {
          forceLogoutInactive();
        }
      } catch (error) {
        if (isNetworkOrServerError(error)) {
          lastNetworkErrorAt.current = Date.now();
          return;
        }
        if (error?.response?.status === 403 && error?.response?.data?.aktif === 'tidak') {
          forceLogoutInactive();
        }
      }
    };

    const intervalId = setInterval(checkStatus, CHECK_INTERVAL_MS);
    checkStatus();

    return () => clearInterval(intervalId);
  }, []);
}
